import { render, staticRenderFns } from "./BannerPoster.vue?vue&type=template&id=7131808e&"
import script from "./BannerPoster.vue?vue&type=script&lang=js&"
export * from "./BannerPoster.vue?vue&type=script&lang=js&"
import style0 from "./BannerPoster.vue?vue&type=style&index=0&id=7131808e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports